function animate_horizontal_scroll() {
    $('.menu__listitems').animate({
        scrollLeft: '+=50'
    }, 750).animate({
        scrollLeft: '-=50'
    }, 750);
}

setTimeout(function() {
    animate_horizontal_scroll();
}, 1000);


// Secondary nav active state on button click
$(document).ready(function() {
    var current = location.pathname;

    if ($('.secondary__nav').length > 0) {
        $('.secondary__nav .menu__listitems li a').each(function() {
            var $this = $(this);
            // if the current path is like this link, make it active
            if ($this.attr('href').indexOf(current) > -1) {
                if (current !== "/en/flights/" && current !== "/bg/poleti/") {
                    $this.addClass('active');
                }
            } else if ($('.single-post').length > 0 && $this.attr('href').indexOf('press-releases') > -1) {
                $this.addClass('active');
            } else if ($('.single-procurement').length > 0 && $this.attr('href').indexOf('procurements') > -1) {
                $this.addClass('active');
            } else if (($this[0].href.indexOf('/for-airlines/') > -1 && current.indexOf('/for-airlines/') > -1) || $this[0].href.indexOf('/za-aviokompanii/') > -1 && current.indexOf('/za-aviokompanii/') > -1) {
                $this.addClass('active');
            } else if (($this[0].href.indexOf('/ecology/') > -1 && current.indexOf('/ecology/') > -1) || $this[0].href.indexOf('/ekologia/') > -1 && current.indexOf('/ekologia/') > -1) {
                $this.addClass('active');
            }
        })
    }
    

});